import { BACKEND_CONSTANTS } from './constants'
import { get } from './helpers'

const getStatuses = async () => get('status', BACKEND_CONSTANTS.STATUS.GET_STATUSES)

export { getStatuses }
